module.exports = __webpack_public_path__ + "static/media/SignUpImg.fca2032d.png";